import React from 'react';
import UniversalLogin from '../auth/UniversalLogin';

const CustomerLogin: React.FC = () => {
  return <UniversalLogin userType="customer" />;
};

export default CustomerLogin;
